export default __webpack_public_path__ + "static/media/poster2.2f9ccc8a.jpg";